
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Comment est-il administré?`}</em></p>
    <p>{`Une seule dose est nécessaire.`}</p>
    <p>{`Si ce vaccin est administré en une seule dose, c’est parce que les études
cliniques ont été menées ainsi. “Comme l’efficacité était bonne, d’autres essais
avec deux doses n’ont pas été réalisés avant la commercialisation, résume Blaise
Genton, responsable médical des campagnes de vaccination du canton de Vaud. Mais
ce produit ne procure pas une meilleure protection après une dose que les
autres.”`}</p>
    <p>{`Selon le Vaudois, il est très probable qu’à terme, une deuxième dose sera
nécessaire. Johnson&Johnson a communiqué le 21 septembre les résultats d'un
essai montrant que si un booster est fourni deux mois après la première
injection, la protection contre le Covid est de 100% contre les formes graves,
et 75% contre les formes modérées ou graves (ce chiffre vaut pour le monde
entier, il est plus élevé aux Etats-Unis).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;